import { Box, Typography } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { getInsurerList } from "../../../../api/area";
import notInsurer from "../../../../assets/image/notInsurer.png";
import SearchInput from "../../../project/searchInput";
import TableInsurer from "../../table/tableInsurer";

export default function Insurer({ dataArea }) {
  const [rowData, setRowData] = useState();
  const [valueSearch, setValueSearch] = useState();
  const gridRef = useRef();
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  useEffect(() => {
    if (dataArea) {
      getInsurerList(dataArea[0]?.areas[0]?.id, "?justHasNotInsurance=true")
        .then((x) => setRowData(x))
        .catch((z) => console.log(z));
    }
  }, [dataArea]);
  return (
    <>
      <Typography
        mt="40px"
        //   onClick={() => setSelected(0)}
        className={"styleSelectedTab"}
      >
        {"بیماران بدون پوشش بیمه"}
      </Typography>
      <Box mt="30px" mb="0px" />
      <SearchInput
        type="text"
        id="filter-text-box"
        onInput={onFilterTextBoxChanged}
        value={valueSearch}
        onChange={(e) => setValueSearch(e.target.value)}
        mb="5px"
        // mr="20px"
      />
      {!rowData?.length > 0 ? (
        <Box
          height="70vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <img src={notInsurer} style={{ marginTop: "50px" }} />
        </Box>
      ) : (
        <>
          <Box height="20px" />
          <TableInsurer
            gridRef={gridRef}
            areaId={dataArea[0]?.areas[0]?.id}
            setRowData={setRowData}
            rowData={rowData}
          />
        </>
      )}
    </>
  );
}
